<div class="upload-list-container">
  <div>
    <div *ngIf="!showFailedMessage; else failedDiv">
      <div class="header">
        <img class="atach-icon" src="../../../../assets/icons/upload-atach.svg" />
        <div class="header-text">
          <label>Carregando anexos.</label>
          <br>
          <label>Por favor, aguarde uns instantes...</label>
        </div>
      </div>
    </div>
    <ng-template #failedDiv>
      <div class="header">
        <img class="atach-icon" src="../../../../assets/icons/upload-atach-warning.svg" />
        <div class="header-text">
          <label>Falha ao carregar {{ fails }} anexo(s).</label>
          <br>
          <label>Tente novamente ou cancele o upload.</label>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="scroll-container">
    <div class="files-list">
      <div *ngFor="let file of files">
        <div class="file-item">
          <app-file-upload-item
            [file]="file"
            [filePathOldStructure]="filePathOldStructure"
            (onFail)="uploadFailed($event)"
            (onStop)="uploadStopped($event)"
            (onSuccess)="uploadSuccess($event)"
          ></app-file-upload-item>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom">
    <div>
      <button class="button-cancel" mat-stroked-button 
        (click)="onCancelClicked()"
      >
        Cancelar
      </button>
    </div>
  </div>
</div>
